import { FilterMethod, ICustomFilter } from '../data-table/components/filters/filters.models';

/**
 * Sentinel column filter — never sent to GET /messages. The Patient search answers it through the
 * patient's claims: it becomes the Patient claim-scope sentinel (claim-scoped-task-listing.ts).
 */
export const PATIENT_NAME_FILTER_ID = 'filterPatientName';
/** Legacy messages patient filter — do not send; the Patient search goes through GET /claims. */
export const PATIENT_ID_FILTER_ID = 'filterPatientId';

const optionId = (raw: unknown): string => {
    if (raw == null || raw === '') {
        return '';
    }
    if (typeof raw === 'object' && raw !== null && 'value' in raw) {
        return String((raw as { value?: unknown }).value ?? '').trim();
    }
    return String(raw).trim();
};

export function parsePatientIdsFromFilters(filters?: ICustomFilter[]): string[] {
    const ids = new Set<string>();
    for (const filter of filters || []) {
        if (filter.filterId !== PATIENT_NAME_FILTER_ID || filter.value == null || filter.value === '') {
            continue;
        }
        const values = Array.isArray(filter.value) ? filter.value : [filter.value];
        for (const value of values) {
            const id = optionId(value);
            if (id) {
                ids.add(id);
            }
        }
    }
    return [...ids];
}

export function buildClaimIdFilters(claimIds: string[]): ICustomFilter[] {
    return claimIds.map(id => ({
        filterId: 'filterClaimId',
        filterMethod: FilterMethod.EQ,
        filterType: 'String',
        value: id,
        label: 'Claim',
    }));
}
